import styled from 'styled-components';

/**
 * Vertically centers a placeholder (e.g. the error `EmptyState`) in the
 * available height. Shared by the SCA list and detail error screens (SEB-1618).
 */
export const CenteredPlaceholder = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-height: 60vh;
`;
